import React, { Component } from "react";
import { Form, FormGroup, ControlLabel, FormControl, Button, Col, Row } from "react-bootstrap";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import cookie from "react-cookies";
import _ from "lodash";

// utils
import { create } from "../../../utils/apiService";

class DevicesForm extends Component {
  constructor(props, context) {
    super(props, context);

    this.handleChange = this.handleChange.bind(this);

    this.state = {
      oc_vwid: "",
      user_name: "",
      description: "",
      description_touched: false
    };

    this.submitForm = this.submitForm.bind(this);
    this.getDescriptionValidationState = this.getDescriptionValidationState.bind(this);
  }

  getDescriptionValidationState() {
    const length = this.state.description.length;
    const touched = this.state.description_touched;

    if (!touched) {
      return null;
    }

    if (length > 1) return "success";
    else if (length >= 0) return "error";
    return null;
  }

  componentDidMount() {
    this.setState({
      oc_vwid: cookie.load("oc_vwid"),
      user_name: this.props.user.name
    });

    if (process.env.REACT_APP_ENV === "development") {
      let random = parseInt(Math.random() * 10000000);
      this.setState({
        oc_vwid: `cookie_id_${random}`,
        description: `description_${random}`,
        user_name: this.props.user.name
      });
    }
  }

  handleChange(e) {
    let touched_label = `${e.target.name}_touched`;
    this.setState({
      [e.target.name]: e.target.value,
      [touched_label]: true
    });
  }
  submitForm(e) {
    e.preventDefault();

    let descriptionValidationState = this.getDescriptionValidationState();

    if (descriptionValidationState === null || descriptionValidationState === "error") {
      console.log("INVALIDO");
      return;
    }

    toastr.info("Registrando device...");

    let url = "/devices";
    let data = {
      device: {
        oc_vwid: this.state.oc_vwid,
        description: this.state.description,
        user_id: this.props.user.id
      }
    };

    console.log(data);

    create(url, data)
      .then(res => {
        toastr.success("Device registrado com sucesso!");
        // this.setState({
        //   name: "",
        //   email: ""
        // });

        let device = res.data;
        console.log(device);

        this.props.success(device);
      })
      .catch(error => {
        console.log(error.response.data);

        let errorMsg = "";

        _.forEach(error.response.data.errors, (errorMsgsArray, field) => {
          errorMsg = _.join(errorMsgsArray, ",");
        });

        toastr.error(`Erro ao registrar device: ${errorMsg}`);
      });

    // console.log("UHUU");

    // let nameValidationState = this.getNameValidationState();
    // let emailValidationState = this.getEmailValidationState();

    // if (nameValidationState === "error" || emailValidationState === "error") {
    //   return;
    // }

    // this.setState({
    //   error: ""
    // });

    // let url = "/users";
    // let data = {
    //   user: {
    //     name: this.state.name,
    //     email: this.state.email
    //   }
    // };

    // toastr.info("Criando usuário...");
    // create(url, data)
    //   .then(res => {
    //     toastr.success("Usuário criado com sucesso!");
    //     this.setState({
    //       name: "",
    //       email: ""
    //     });
    //   })
    //   .catch(err => {
    //     toastr.error("Erro ao criar usuário...");
    //   });
  }
  render() {
    return (
      <div className="users-form">
        <h2>Registrando novo Device</h2>
        <Form onSubmit={this.submitForm}>
          <Row>
            <Col md={3}>
              <FormGroup controlId="formBasicText">
                <ControlLabel>CookieId:</ControlLabel>
                <FormControl type="text" name="oc_vwid" value={this.state.oc_vwid} disabled={true} />
                <FormControl.Feedback />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup controlId="formBasicText">
                <ControlLabel>Nome:</ControlLabel>
                <FormControl type="text" name="name" value={this.state.user_name} disabled={true} />
                <FormControl.Feedback />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup controlId="formBasicText" validationState={this.getDescriptionValidationState()}>
                <ControlLabel>Descrição:</ControlLabel>
                <FormControl
                  type="text"
                  name="description"
                  value={this.state.description}
                  placeholder="exemplo: Chrome Desktop"
                  onChange={this.handleChange}
                />
                <FormControl.Feedback />
              </FormGroup>
            </Col>
            <Col md={2}>
              <Button style={{ marginTop: "25px" }} type="submit">
                Registrar
              </Button>
            </Col>
            {/* <Col md={12}>
              <small className="text-danger">{this.state.error}</small>
            </Col> */}
          </Row>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.app.user
});

export default connect(mapStateToProps)(DevicesForm);



// WEBPACK FOOTER //
// ./src/components/pages/Devices/DevicesForm.js